package diana.soleil.design.iraniancanadienbazzar.core.model

/**
 * A business-run **community channel** (`channels/{businessId}` — one per claimed business): a
 * broadcast feed where the owner posts updates and followers read them. Membership is the existing
 * follow relationship (`follows/{uid}_{businessId}`), so "join" == follow. See `docs/DATA_MODEL.md`.
 */
data class Channel(
    /** Also the document id — one channel per business. */
    val businessId: String,
    /** Business display name, snapshotted at creation so lists render without a business lookup. */
    val name: String,
    val ownerUid: String,
    /** Inbox preview of the newest post (owner-maintained on every post, like chat threads). */
    val lastPostText: String? = null,
    val lastPostAtMillis: Long? = null,
)

/** One broadcast post in a channel (`channels/{businessId}/posts/{id}`). Owner-authored, text-only. */
data class ChannelPost(
    val id: String,
    val text: String,
    val createdAtMillis: Long? = null,
)
